module.exports = __webpack_public_path__ + "img/contact.74160cc2.png";